Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    coachmarkMarkerBackgroundColorDefault: tokens.themeBorderAccentDefault,
    coachmarkMarkerBackgroundColorHover: tokens.themeForegroundAccentHover,
    coachmarkMarkerBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    coachmarkMarkerMotionDuration: "100ms",
    coachmarkMarkerMotionFunction: "ease",
    coachmarkMarkerSize: 12,
    coachmarkMarkerRadius: 999,
    coachmarkMarkerSpacingInset: 6,
    coachmarkOrbBorderColor: tokens.themeBorderAccentDefault,
    coachmarkOrbBorderWidth: 2,
    coachmarkOrbBorderRadius: 999,
    coachmarkOrbSizeStart: 12,
    coachmarkOrbSizeEnd: 40,
    coachmarkOrbMotionTiming: "700ms",
    coachmarkOrbMotionFunction: "ease"
  }
};